import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Public Pages
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Hero from '../Pages/Hero';
import Features from '../Pages/Features';
import MarketOverview from '../Pages/MarketOverview';
import Pricing from '../Pages/Treding';
import Testimonials from '../Pages/Testimonials';
import FAQ from '../Pages/FAQ';
import CTA from '../Pages/CTA';
import MarketSection from '../Pages/MarketSection';
import AssociatePartner from '../Pages/AssociatePartner';
import TrustedSection from '../Pages/TrustedSection';
import AboutUs from '../Pages/AboutUs';
import Services from '../Pages/Services';
import ContactUs from '../Pages/ContactUs';
import ScrollToTop from '../Component/ScrollToTop';

// Customer Protected Pages
import AccountLayout from '../Customer/components/AccountLayout';
import AccountDashboard from '../Customer/pages/AccountDashboard';
import Register from '../Customer/Register';
import Portfolio from '../Customer/pages/Portfolio';
import Transactions from '../Customer/pages/Transactions';
import Profile from '../Customer/pages/Profile';
import Security from '../Customer/pages/Security';
import ViewAccount from '../Customer/pages/ViewAccount';
import Disclaimer from '../Pages/Disclaimer';
import TermsOfService from '../Pages/TermsOfService';

// Note: Agar Disclaimer aur Terms of Service ke pages banaye hain, 
// toh unhe yahan import kar lena, maine abhi ke liye routes me unhe blank div diya hai.
// import Disclaimer from '../Pages/Disclaimer';
// import Terms from '../Pages/Terms';

const HomePage = () => {
  return (
    <>
      <Hero />
      <MarketSection />
      <AssociatePartner />
      <Features />
      <MarketOverview />
      <Pricing />
      <CTA />
      <TrustedSection />
      <Testimonials />
      {/* FAQ ko layout se hata kar yahan Home page par rakh diya hai */}
      <FAQ /> 
    </>
  );
};

// MainLayout se FAQ hata diya hai taaki har ek page par faltu me na dikhe
const MainLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="bg-slate-950 text-white font-sans antialiased min-h-screen flex flex-col">
    <Header />
    <main className="flex-grow">{children}</main>
    <Footer />
  </div>
);

export const AppRoutes = () => {
  return (
    <BrowserRouter>
      {/* Global ScrollToTop: Ab har page change hone par screen automatically top par jayegi */}
      <ScrollToTop />
      
      <Routes>
        {/* ======================================= */}
        {/* 1. PUBLIC ROUTES (Home, About, Contact) */}
        {/* ======================================= */}
        <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
        <Route path="/demat/register" element={<MainLayout><Register /></MainLayout>} />
        <Route path="/about" element={<MainLayout><AboutUs /></MainLayout>} />
        <Route path="/services" element={<MainLayout><Services /></MainLayout>} />
        <Route path="/contact" element={<MainLayout><ContactUs /></MainLayout>} />
        
        {/* ======================================= */}
        {/* 2. FOOTER INDIVIDUAL ROUTES             */}
        {/* ======================================= */}
        <Route path="/market-overview" element={<MainLayout><MarketOverview /></MainLayout>} />
        <Route path="/features" element={<MainLayout><Features /></MainLayout>} />
        <Route path="/pricing" element={<MainLayout><Pricing /></MainLayout>} />
        <Route path="/testimonials" element={<MainLayout><Testimonials /></MainLayout>} />
        <Route path="/faq" element={<MainLayout><FAQ /></MainLayout>} />
        <Route path="/partner" element={<MainLayout><AssociatePartner /></MainLayout>} />
        
        {/* Agar aage chalkar Disclaimer aur Terms page banao, toh in routes me component daal dena */}
        <Route path="/disclaimer" element={<MainLayout><Disclaimer /></MainLayout>} />
        <Route path="/terms" element={<MainLayout><TermsOfService /></MainLayout>} />

        {/* ======================================= */}
        {/* 3. SECURE CUSTOMER ROUTES               */}
        {/* ======================================= */}
        <Route 
          path="/account/dashboard" 
          element={
            <AccountLayout>
              <AccountDashboard />
            </AccountLayout>
          } 
        />
        <Route path="/account/portfolio" element={<AccountLayout><Portfolio /></AccountLayout>} />
        <Route path="/account/transactions" element={<AccountLayout><Transactions /></AccountLayout>} />
        <Route path="/account/profile" element={<AccountLayout><Profile /></AccountLayout>} />
        <Route path="/account/security" element={<AccountLayout><Security /></AccountLayout>} />
        <Route path="/account/view-account" element={<AccountLayout><ViewAccount /></AccountLayout>} />
      </Routes>
    </BrowserRouter>
  );
}